import { fetch } from '@atlassian/eoc-fetch';

import type {
	ForwardingRulesResponse,
	NotificationPreferencesResponse,
	RoleBasedNotificationResponse,
} from '../../common/types';
import { getTargetAccountIdSuffix } from '../../common/utils';

export const getNotificationPreferences = (
	targetAccountId: string | undefined | null,
): Promise<NotificationPreferencesResponse | RoleBasedNotificationResponse> =>
	fetch<NotificationPreferencesResponse | RoleBasedNotificationResponse>(
		`/v1/users/notification-preferences${getTargetAccountIdSuffix(targetAccountId)}`,
	);

export const getForwardingRules = (
	targetAccountId: string | undefined | null,
): Promise<ForwardingRulesResponse> =>
	fetch<ForwardingRulesResponse>(
		`/v1/alerts/notifications/forwarding-rules${getTargetAccountIdSuffix(targetAccountId)}`,
	);
